import { type AmendmentVisibility } from '@/features/jobs/Job'
import { match } from '@/utils/pattern-match-util'

/**
 * Formats the amendment visibility to a string.
 * @param visibility Amendment visibility enum.
 * @returns Visibility as `string`.
 */
export function formatVisibility(visibility: AmendmentVisibility): string {
  return match(visibility, {
    Public: () => 'Public',
    Internal: () => 'Internal',
  })
}
